import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { BrowserRouter } from "react-router-dom";

import { FirebaseProvider } from "./hooks/useFirebase";
import firebaseConfig from "./firebaseConfig";

import "./index.css";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <FirebaseProvider config={firebaseConfig} enablePersistence={true}>
        <App />
      </FirebaseProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// https://bit.ly/CRA-PWA
serviceWorker.unregister();
